import { COMPANY_DETAILS_CONSTANT } from '../actionConstants';
import { actionCreator, failedFor, successFor } from '../sagaUtil';
// update API actionsx
export const updateCompanyDetails = (payload) => ({
	type: COMPANY_DETAILS_CONSTANT.UPDATE_COMPANY_DETAILS_CALLED,
	payload
});
export const updateCompanyDetailsSuccess = () => ({
	type: COMPANY_DETAILS_CONSTANT.UPDATE_COMPANY_DETAILS_SUCCESS
});
export const updateCompanyDetailsFailed = () => ({
	type: COMPANY_DETAILS_CONSTANT.UPDATE_COMPANY_DETAILS_FAILED
});

export const getCurrencies = actionCreator(COMPANY_DETAILS_CONSTANT.GET_CURRENCIES_API);
export const getCurrenciesSuccess = actionCreator(successFor(COMPANY_DETAILS_CONSTANT.GET_CURRENCIES_API));
export const getCurrenciesFailed = actionCreator(failedFor(COMPANY_DETAILS_CONSTANT.GET_CURRENCIES_API));

export const getApiKeys = actionCreator(COMPANY_DETAILS_CONSTANT.GET_API_KEYS);
export const getApiKeysSuccess = actionCreator(successFor(COMPANY_DETAILS_CONSTANT.GET_API_KEYS));
export const getApiKeysFailed = actionCreator(failedFor(COMPANY_DETAILS_CONSTANT.GET_API_KEYS));

export const updateApiKeys = actionCreator(COMPANY_DETAILS_CONSTANT.UPDATE_API_KEYS);
export const updateApiKeysSuccess = actionCreator(successFor(COMPANY_DETAILS_CONSTANT.UPDATE_API_KEYS));
export const updateApiKeysFailed = actionCreator(failedFor(COMPANY_DETAILS_CONSTANT.UPDATE_API_KEYS));
